export default "__VITE_ASSET__BHwGDnju__"